module.exports = __webpack_public_path__ + "img/wrap.3542130d.png";